import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

/**
 * Generated class for the FastToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "comatose-tool",
  templateUrl: "comatose-tool.html",
})
export class ComaToseToolComponent {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  id: string;
  componentId: string;
  label: string;
  declinable: boolean;
  values: object = {};
  readonly: boolean = false;
  initialized: boolean = false;

  innerGroup: FormGroup;
  default: string;

  comaToseToggleValue: boolean;
  comaToseToggle: Boolean;
  comaToseScoreValue: string;
  comaToseScore: Boolean = true;
  readonlyVerbalResponse: Boolean = false;
  verbalResponseScore;
  readonlyEyeResponse: Boolean = false;
  eyeResponseScore;
  readonlyMotorResponse: Boolean = false;
  motorResponseScore;
  text: string;
  constructor(
    public translatePipe: TranslateService,
    public formBuilder: FormBuilder
  ) {
    // console.log('Hello ToolCardComponent Component');
  }

  ngOnInit(): void {
    //console.log( "Incoming configuration for question card: ", this.config );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.declinable = this.config.declinable;
    this.readonly = this.config.readonly;
    this.valueChanged(false, false);

    this.innerGroup = this.formBuilder.group({});
    let formState = this.default !== undefined ? this.default : null;
    this.innerGroup.addControl(
      "verbalResponseRadio",
      this.formBuilder.control(formState)
    );
    this.innerGroup.addControl(
      "eyeResponseRadio",
      this.formBuilder.control(formState)
    );
    this.innerGroup.addControl(
      "motorResponseRadio",
      this.formBuilder.control(formState)
    );
    this.innerGroup.addControl(
      "comaTotalText",
      this.formBuilder.control(formState)
    );
  }

  @Input() set data(incomingData: any) {
    // console.log( "Tool card Data: ", this.data );
    // console.log( "Tool card Incoming data: ", incomingData );

    if (incomingData) {
      console.log("Loaded data for coma tool card: ", incomingData);
      let cardData = incomingData;
      if (cardData.data) {
        if (cardData.data[0].comaTose) {
          if (
            cardData.data[0].comaTose.comaToseScore != null &&
            cardData.data[0].comaTose.comaToseScore != undefined
          ) {
            this.comaToseScoreValue = cardData.data[0].comaTose.comaToseScore;
          }

          if (
            cardData.data[0].comaTose.verbalResponse != null &&
            cardData.data[0].comaTose.verbalResponse != undefined
          ) {
            this.verbalResponseScore = cardData.data[0].comaTose.verbalResponse;
          }

          if (
            cardData.data[0].comaTose.eyeResponse != null &&
            cardData.data[0].comaTose.eyeResponse != undefined
          ) {
            this.eyeResponseScore = cardData.data[0].comaTose.eyeResponse;
          }

          if (
            cardData.data[0].comaTose.motorResponse != null &&
            cardData.data[0].comaTose.motorResponse != undefined
          ) {
            this.motorResponseScore = cardData.data[0].comaTose.motorResponse;
          }

          if (
            cardData.data[0].comaTose.comaTosetoggle != null &&
            cardData.data[0].comaTose.comaTosetoggle != undefined
          ) {
            this.comaToseToggleValue = cardData.data[0].comaTose.comaTosetoggle;
            if (this.comaToseToggleValue) {
              this.valueChanged(true, false);
            } else {
              this.valueChanged(false, false);
            }
          }
        }
      }
    }

    if (this.readonly || this.disabled) {
      this.comaToseToggle = true;
      this.readonlyVerbalResponse = true;
      this.readonlyEyeResponse = true;
      this.readonlyMotorResponse = true;
    }

    if (incomingData !== undefined && !this.initialized) {
      // console.log( "Flagging tool card as initialized.", this.id );
      this.initialized = true;
      this.onCardInitialized.emit(this.id);
    }
  }

  valueChanged(val: boolean, clear: boolean) {
    if (clear) {
      this.clearValues();
    }
    this.comaToseToggleValue = val;
    if (val == true) {
      this.readonlyVerbalResponse = false;
      this.readonlyEyeResponse = false;
      this.readonlyMotorResponse = false;
    } else {
      this.readonlyVerbalResponse = true;
      this.readonlyEyeResponse = true;
      this.readonlyMotorResponse = true;
    }
    this.computeScore(val);
  }

  clearValues() {
    this.verbalResponseScore = null;
    this.eyeResponseScore = null;
    this.motorResponseScore = null;
    this.comaToseScoreValue = null;
  }

  computeScore(val) {
    let scoreSum = 0;
    let numScored = 0;

    if (
      this.verbalResponseScore !== undefined &&
      this.verbalResponseScore != null
    ) {
      scoreSum += this.verbalResponseScore * 1;
      numScored++;
    }

    if (this.eyeResponseScore !== undefined && this.eyeResponseScore != null) {
      scoreSum += this.eyeResponseScore * 1;
      numScored++;
    }

    if (
      this.motorResponseScore !== undefined &&
      this.motorResponseScore != null
    ) {
      scoreSum += this.motorResponseScore * 1;
      numScored++;
    }

    if (scoreSum >= 9 && scoreSum < 15) {
      this.text = "Best Response";
    }

    if (scoreSum >= 4 && scoreSum < 9) {
      this.text = "Comatose Patient";
    }

    if (scoreSum <= 3) {
      this.text = "Totally Unresponsive";
    }

    if (scoreSum == 0) {
      this.text = "";
    }

    if (numScored == 0) {
      this.values["comaTose"] = {
        comaTosetoggle: this.comaToseToggleValue,
        comaToseScore: null,
        verbalResponse: null,
        eyeResponse: null,
        motorResponse: null,
      };
      if (!this.readonly) {
        this.onDataUpdate.emit({
          cardId: this.id,
          value: this.values,
        });
      }
      return;
    } else {
      this.comaToseScoreValue =
        scoreSum.toString() == "0" ? null : scoreSum.toString();
    }

    if (
      this.comaToseScoreValue != undefined &&
      this.comaToseScoreValue != null &&
      this.verbalResponseScore != undefined &&
      this.eyeResponseScore != undefined &&
      this.motorResponseScore != undefined
    ) {
      this.values["comaTose"] = {
        comaTosetoggle: this.comaToseToggleValue,
        comaToseScore: this.comaToseScoreValue,
        verbalResponse: this.verbalResponseScore,
        eyeResponse: this.eyeResponseScore,
        motorResponse: this.motorResponseScore,
      };
      if (!this.readonly) {
        this.onDataUpdate.emit({
          cardId: this.id,
          value: this.values,
        });
      }
    }
  }

  verbalResponseChanged(data) {
    this.verbalResponseScore = data;
    this.computeScore(data);
  }

  eyeResponseChanged(data) {
    this.eyeResponseScore = data;
    this.computeScore(data);
  }

  motorResponseChanged(data) {
    this.motorResponseScore = data;
    this.computeScore(data);
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/comatose-tool/comatose-tool.ts